import React from "react";

import MenuInteremedioNiveles from "../menuInteremedioNiveles";
import CarruselPrimario from '../../proyectoeducativo/nivelprimario/carruselPrimaria';
import "../nivelesPages.css";

function HomePrimario() {
  return (
    <div className="levels-page">

      <CarruselPrimario />

      <div className="levels-menu-shell">
        <MenuInteremedioNiveles />
      </div>
 
      <div id ="texto-primaria" className="levels-text-card">
        <h2 className="text-white text-center mb-4" style={{ fontWeight: "bold", letterSpacing: "1px" }}>
       Nivel Primario 
        </h2>

        <p className="lead text-white fs-5" style={{ lineHeight: "1.8", marginBottom: "24px" }}>
         El Colegio Santo Tomás se propone fortalecer y ampliar los conocimientos adquiridos en el Nivel Inicial, acompañando el crecimiento de cada estudiante en todas sus dimensiones: académica, emocional, social y ética.
        </p>

        <p className="text-white fs-5" style={{ lineHeight: "1.8", marginBottom: "20px" }}>
          Nuestra propuesta educativa se sustenta en un enfoque pedagógico que integra contenidos curriculares con el desarrollo del pensamiento crítico, el trabajo colaborativo y la formación en valores. Fomentamos un ambiente de aprendizaje que estimula la curiosidad, la creatividad y la participación activa en proyectos, respetando los tiempos individuales y promoviendo la autonomía progresiva de cada alumno.
        </p>

        <p className="text-white fs-5" style={{ lineHeight: "1.8", marginBottom: "20px" }}>
          A lo largo de esta etapa, se trabaja de manera transversal el respeto por la diversidad, la empatía, la responsabilidad y el compromiso con la comunidad. Los docentes, con dedicación y cercanía, acompañan cada proceso de aprendizaje, generando vínculos significativos que fortalecen la confianza y el deseo de aprender.
        </p>
 
      </div>



    </div>







  );
}

export default HomePrimario;

